import React from "react";
//import { useHistory } from 'react-router-dom';
import { BackButton } from "../../components";
import { useLocation } from "react-router-dom";
import { FiChevronDown } from "react-icons/fi";

const ROLE_LABELS = {
  0: "Admin",
  1: "Teacher",
  2: "Bursar",
  3: "Academic Admin",
  admin: "Admin",
  teacher: "Teacher",
  burser: "Bursar",
  academic_admin: "Academic Admin",
};

export default function ViewAdmin({ history }) {
  const location = useLocation();
  const admin = location.state?.admin;

  return (
    <div className="w-full flex flex-col items-center justify-center py-24 md:py-9 px-8">
      <div className="bg-white w-full px-7 py-9 rounded-[40px]">
        <BackButton history={history} />

        <div className="flex flex-wrap items-start justify-between mt-4">
          <div className="sm:w-max w-full sm:mb-0 mb-3">
            <div className="flex items-center">
              <p className="inline text-2xl font-semibold">
                {admin?.firstname} {admin?.lastname}
              </p>
              <button className="flex items-center justify-between bg-[#5FC3811A] text-[#5FC381] text-[14px] py-1 px-2 rounded-full ml-3">
                <p className="mr-1">Active</p>
                <FiChevronDown />
              </button>
            </div>
            <p className="text-[14px] mt-3">{admin?.email}</p>
            <p className="text-[14px] mt-3">{admin?.mobile_number}</p>
          </div>
        </div>
      </div>

      <div className="bg-white w-full rounded-[40px] p-6 mt-4">
        <h3 className="text-lg font-semibold mb-4">Additional Information</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="p-4 bg-gray-50 rounded-lg">
            <p className="text-sm text-gray-600">Gender</p>
            <p className="text-base font-medium mt-1">{admin?.gender || "Not specified"}</p>
          </div>
          <div className="p-4 bg-gray-50 rounded-lg">
            <p className="text-sm text-gray-600">Role</p>
            <p className="text-base font-medium mt-1">
              {ROLE_LABELS[admin?.role] || "Administrator"}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
